export default "__VITE_ASSET__BfyGSswg__"